module.exports = __webpack_public_path__ + "img/mini_icon.376d2633.png";